module.exports = __webpack_public_path__ + "static/media/keyboard_arrow_right.dc50b8db.svg";